import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground shadow",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive text-destructive-foreground shadow",
        outline: "text-foreground",
      },
    },
    defaultVariants: { variant: "default" },
  }
)

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

/** forwardRef is required on React 18 — see the note in button.tsx. A Badge is
 *  used as a `<TooltipTrigger asChild>` child, which needs the ref to anchor. */
const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  function Badge({ className, variant, ...props }, ref) {
    return <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
  }
)
export { Badge, badgeVariants }
